import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";
export default {
  name: 'ArrowPrev',
  functional: true,
  render: function (h, ctx) {
    return h(
      "svg",
      _mergeJSXProps([{
        attrs: { width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }
      }, ctx.data]),
      [h("path", {
        attrs: { d: "m2 12 7.707 7.707 1.414-1.414L5.828 13h16.176v-2H5.828l5.293-5.293-1.414-1.414L2 12Z" }
      })]
    );
  }
};